import React from 'react';

const AboutClient = () => {
    return (
        <section id="about" className="aboutArea">
            <div className="container">
                <h1 className="title-font">Bienvenue chez Impôt MaxDC</h1>
                <h6 className="subtext-font">
                    Service en ligne de préparation de déclarations d'impôts des particuliers
                </h6>
                <h6 className="subtext-font">
                    Nous sommes là pour vous simplifier la vie avec vos impôts !
                </h6>
            </div>
        </section>
    );
};

export default AboutClient;